import log = require('loglevel');
import { Logger } from 'loglevel';

export interface IMessageRecord {
  type: string;
  title?: string;
  doc?: string;
  zh_CN?: string;
  en_US?: string;
};

export interface ILogEnv {
  [env: string]: string;
}

export interface ILogMessageMap {
  [errorId: string]: IMessageRecord;
}

export interface ILoggerConfigs {
  defaultErrorDocUrl?: string;
}

const LOG_ENV = {
  dev: 'TRACE',
  test: 'WARN',
  production: 'ERROR',
}
const LOG_LEVEL = ['trace', 'error', 'info', 'debug', 'warn'];
const DEFAULT_DOC_ADDRESS = 'https://lark.alipay.com/vision/error';

let loggerInstance: LoggerManager;

export class LoggerManager {
  public logMessageMap: ILogMessageMap = {};
  public logLevel: string;
  public logEnv: keyof ILogEnv;
  public logger: Logger;
  public configs: ILoggerConfigs;
  public lang: string = 'zh_CN';

  constructor(configs?: ILoggerConfigs) {
    this.configs = configs || {};
    this.logger = log;
  }

  public setLang(lang: string) {
    this.lang = lang;
  }

  public getLang() {
    return this.lang;
  }

  public setEnv(env: keyof ILogEnv) {
    this.logEnv = env;
    this.logger.setLevel(LOG_ENV[env]);
  }

  public getEnv() {
    return this.logEnv;
  }

  public setLogLevel(level: any) {
    this.logger.setLevel(level);
  }

  public getLogLevel() {
    return this.logger.getLevel();
  }

  public setLogMap(errorMap: ILogMessageMap) {
    this.logMessageMap = Object.assign(this.logMessageMap, errorMap);
  }

  public getLogMap() {
    return this.logMessageMap;
  }

  public log(logTypeName: string) {
    const logRecord = this.logMessageMap[logTypeName];
    if (logRecord && logRecord.type) {
      if (LOG_LEVEL.indexOf(logRecord.type) < 0) {
        logRecord.type = 'info';
      }
      const docUrl = logRecord.doc || this.configs.defaultErrorDocUrl || DEFAULT_DOC_ADDRESS;
      this.logger[logRecord.type].call(
        null,
        `${logRecord.title || logRecord.type.toUpperCase()}: ${logRecord[this.lang]} see %o`,
        docUrl);
    } else {
      this.logger.info('Unknown Log Type: 未知 Log 类型');
    }
  }

  trace(...args: any[]) {
    loggerInstance.logger.trace.apply(null, args);
  }

  debug(...args: any[]) {
    loggerInstance.logger.debug.apply(null, args);
  }

  info(...args: any[]) {
    loggerInstance.logger.info.apply(null, args);
  }

  warn(...args: any[]) {
    loggerInstance.logger.warn.apply(null, args);
  }

  error(...args: any[]) {
    loggerInstance.logger.error.apply(null, args);
  }
}

loggerInstance = new LoggerManager();

export default loggerInstance;



// WEBPACK FOOTER //
// ./src/index.ts


// WEBPACK FOOTER //
// webpack:///src/index.ts